// removed by extract-text-webpack-plugin
module.exports = {"sectionHeader":"src-components-sectionHeader----sectionHeader-module---sectionHeader---17JM6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sectionHeader/sectionHeader.module.scss
// module id = 291
// module chunks = 95715928098905 199248266171276